import { defineComponent } from "vue";

import { Container } from "aurelia-dependency-injection";

import { AgencyService } from "../../services/agency.service";
import { AnalyticsCategory, AnalyticsService } from "../../services/analytics.service";
import { BranchesService } from "../../services/branches-service";
import { AgencyEvents } from "../App/components/AgencyList/AgencyList";
import eventBus from "../../utilities/eventBus";
import banner4 from "../../../img/axxess-intelligence44.png";
import banner5 from "../../../img/axxess-connect55.png";
import banner6 from "../../../img/axxess-central60.png";

import DashboardHeader from "../../resources-vue/vue-elements/DashboardHeader/DashboardHeader.vue";
import PersonalHelp from "./components/PersonalHelp/PersonalHelp.vue";
import PersonalTraining from "./components/PersonalTraining/PersonalTraining.vue";
import PersonalMessageList from "./components/PersonalMessageList/PersonalMessageList.vue";
import PlannerLevelTwo from "../AxxessHome/components/PlannerLevelTwo/PlannerLevelTwo.vue";
import EmployeeList from "../Common/EmployeeList/EmployeeList.vue";
import PatientList from "../Common/PatientList/PatientList.vue";

export default defineComponent({
    components: {
        PersonalHelp,
        PersonalTraining,
        PersonalMessageList,
        DashboardHeader,
        PlannerLevelTwo,
        EmployeeList,
        PatientList
    },

    data(vm) {
        return {
            ea: null,
            agencyService: null,
            analyticsService: null,
            _branchService: null,
            name: null,
            hasAgencyCore: true,
            hasHomeCare: true,
            showEmployees: false,
            showPatients: false,
            banners: [
                { src: banner4, link: "https://www.axxess.com/help/agencycore/axxess-intelligence/ask-axxess/" },
                { src: banner5, link: "https://www.axxess.com/help/axxess-central/axxess-connect/" },
                { src: banner6, link: "https://www.axxess.com/help/axxess-central/" }
            ],
            banner: { src: "", link: "" },
            intervalId: null as any,
            showBanner: true,
        };
    },

    async mounted() {
        this.intervalId = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * this.banners.length);
            this.banner = this.banners[randomIndex];
        }, 20000);
    },

    created() {
        this.agencyService = Container.instance.get(AgencyService);
        this.analyticsService = Container.instance.get(AnalyticsService);
        this._branchService = Container.instance.get(BranchesService);
        this.logUserApplications();
        eventBus.on(AgencyEvents.Loaded, () => {
            this.hasAgencyCore = this.agencyService.getHasAgencyCore();
            this.hasHomeCare = this.agencyService.getHasHomeCore();
            this.logUserApplications();
        });
        const randomIndex = Math.floor(Math.random() * this.banners.length);
        this.banner = this.banners[randomIndex];
    },

    methods: {
        logUserApplications(): void {
            if (this.hasAgencyCore && this.hasHomeCare) {
                this.analyticsService.logEvent({
                    category: "User-Applications",
                    action: "AC & HC"
                });
            }
        },
        closeBanner() {
            this.showBanner = false;
            clearInterval(this.intervalId);
        },
        addLog() {
            this.analyticsService.logEvent({
                category: AnalyticsCategory.Banners,
                action: "footer-banner"
            });
        },
        addAgileLog() {
            this.analyticsService.logEvent({
                category: AnalyticsCategory.Banners,
                action: "agile-banner"
            });
        }
    }
});
